export const whenHoveringLink = 'hover:brightness-125 hover:active:brightness-150 transition-[filter]';
export const whenHoveringButton = 'hover:opacity-85 hover:active:opacity-50 transition-opacity';
export const disableFocusing = 'outline-hidden';